import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "./contexts/ThemeContext";
import { AuthProvider } from "./contexts/AuthContext";
import { SupportProvider } from "./contexts/SupportContext";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SupportDialog from "./components/SupportDialog";
import SupportButton from "./components/SupportButton";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import CreateCagnotte from "./pages/CreateCagnotte";
import EditCagnotte from "./pages/EditCagnotte";
import CagnottePublic from "./pages/CagnottePublic";
import Explore from "./pages/Explore";
import About from "./pages/About";
import Profile from "./pages/Profile";
import AuthCallback from "./pages/AuthCallback";
import Tontines from "./pages/Tontines";
import TontineCreate from "./pages/TontineCreate";
import TontineDetail from "./pages/TontineDetail";
import TontineJoin from "./pages/TontineJoin";
import Admin from "./pages/Admin";
import Protected from "./components/Protected";
import AdminProtected from "./components/AdminProtected";
import ScrollToTop from "./components/ScrollToTop";

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth callback (session_id in URL fragment)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/about" element={<About />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/cagnotte/new" element={<Protected><CreateCagnotte /></Protected>} />
          <Route path="/cagnotte/:id/edit" element={<Protected><EditCagnotte /></Protected>} />
          <Route path="/cagnotte/:id" element={<CagnottePublic />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/profile" element={<Protected><Profile /></Protected>} />
          <Route path="/tontines" element={<Protected><Tontines /></Protected>} />
          <Route path="/tontines/new" element={<Protected><TontineCreate /></Protected>} />
          <Route path="/tontines/join/:token" element={<Protected><TontineJoin /></Protected>} />
          <Route path="/tontines/:id" element={<Protected><TontineDetail /></Protected>} />
          <Route path="/admin" element={<AdminProtected><Admin /></AdminProtected>} />
        </Routes>
      </main>
      <Footer />
      <SupportButton />
      <SupportDialog />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <SupportProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster richColors position="top-right" />
          </BrowserRouter>
        </SupportProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
